import { Theme, css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { useIntl } from 'gatsby-plugin-react-intl'
import { FC } from 'react'

import Container from '../../../components/Container'
import { useIntlLabel } from '../../../intl'
import ItemMinistryInstitution from './ItemMinistryInstitution'
import { HomeMinistriesInstitutionsSectionQuery } from './__generated__/HomeMinistriesInstitutionsSectionQuery'

const ContainerStyled = styled.section((props) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: ['DM Sans', 'sans-serif'].join(','),
    padding: '80px 0',
    backgroundColor: props.theme.sections.serviceMinistries.background,
    boxSizing: 'border-box',
    color: props.theme.sections.serviceMinistries.foreground,
}))

const TitleStyled = styled.h2({
    fontSize: 24,
    fontWeight: 700,
    margin: '0 0 40px 0',
})

const ContainerListStyled = styled.div((props) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: 1106,
    [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {
        flexDirection: 'column',
        alignItems: 'center',
    },
}))

const ContainerButtonStyled = styled.div({
    display: 'flex',
    justifyContent: 'center',
})

const linkStyle = (theme: Theme) =>
    css({
        borderRadius: 4,
        backgroundColor: theme.sections.serviceMinistries.backgroundButton,
        color: theme.sections.serviceMinistries.foregroundButton,
        width: 246,
        height: 52,
        cursor: 'pointer',
        marginTop: 40,
        textDecoration: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    })

const Element = styled.ul({
    width: '100%',
    margin: '0',
    padding: '0',
})

const ContainerStyledInner = styled.div({
    display: 'flex',
})

const HomeMinistriesInstitutionsSection: FC = () => {
    const intl = useIntl()

    const getIntlLabel = useIntlLabel()

    const { allStrapiMinistries, strapiHome } =
        useStaticQuery<HomeMinistriesInstitutionsSectionQuery>(graphql`
            query HomeMinistriesInstitutionsSectionQuery {
                allStrapiMinistries(limit: 6, sort: { order: DESC, fields: created_at }) {
                    nodes {
                        ministryName
                        ministryName_mg
                        ministrySlug
                        ministrySlug_mg
                        id
                    }
                }
                strapiHome {
                    titleMinistriesAndOrganizations
                    titleMinistriesAndOrganizations_mg
                }
            }
        `)

    return (
        <ContainerStyled>
            <Container>
                <TitleStyled>
                    {getIntlLabel(strapiHome, 'titleMinistriesAndOrganizations')}
                </TitleStyled>

                <ContainerStyledInner>
                    <ContainerListStyled>
                        <Element>
                            {allStrapiMinistries.nodes.map((item: any) => (
                                <ItemMinistryInstitution key={item.id} {...item} isInHome={true} />
                            ))}
                        </Element>
                    </ContainerListStyled>
                </ContainerStyledInner>

                <ContainerButtonStyled>
                    <Link css={linkStyle} to={'/ministeres'}>
                        {intl.formatMessage({ id: 'site_see_complet_list' })}
                    </Link>
                </ContainerButtonStyled>
            </Container>
        </ContainerStyled>
    )
}

export default HomeMinistriesInstitutionsSection
